import { createActions } from 'redux-actions';

export const { updateGuestEvents } = createActions('UPDATE_GUEST_EVENTS');
